var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIdcardicon2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 10,
    viewBox: "0 0 9 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.52177 5.75078C5.3478 5.86643 5.14569 5.92875 4.93652 5.92875C4.72836 5.92875 4.52623 5.86743 4.35125 5.75078L1.48327 3.83913C1.46718 3.82806 1.4521 3.81699 1.43701 3.80593V6.93939C1.43701 7.29839 1.72863 7.584 2.0816 7.584H7.79243C8.15243 7.584 8.43701 7.29236 8.43701 6.93939V3.80593C8.42193 3.81699 8.40685 3.82806 8.39076 3.83913L5.52277 5.75078H5.52177ZM1.71154 3.4972L4.57953 5.40886C4.68813 5.48126 4.81283 5.51747 4.93652 5.51747C5.06122 5.51747 5.18489 5.48126 5.2945 5.40886L8.16248 3.4972C8.33444 3.38257 8.43701 3.19152 8.43701 2.98436C8.43701 2.62938 8.14841 2.34076 7.79343 2.34076H2.0826C1.72762 2.34076 1.43802 2.63039 1.43802 2.98537C1.43802 3.19152 1.54059 3.38357 1.71255 3.4972H1.71154Z",
    fill: "#E31F25"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIdcardicon2);
export default __webpack_public_path__ + "static/media/idcardicon2.5510667cabb3e6addaa7e3b93b0cf76e.svg";
export { ForwardRef as ReactComponent };